// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmPayoutDialog-Error_cls1__ZKcdM","cls2":"ConfirmPayoutDialog-Error_cls2__-4h2q ConfirmPayoutDialog-Error_cls1__ZKcdM"};